import React from 'react';

import LabelField from '../../../components/plain/LabelField';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldDecimal from '../../../components/plain/FieldDecimal';
import FieldList_Strings from '../../../components/plain/FieldList_Strings';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

class TabAAEvents extends React.Component {

	constructor(props) {
		super(props);
	}

	eventCardBuilder = (fieldEvent, index) => {
		let card = '';
		if( fieldEvent.value.name.value )
			card += fieldEvent.value.name.value;
		return card;
	}
	buildEventPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<EventPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/events'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildEventPanel} itemCardBuilder={this.eventCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class EventPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	descriptionCardBuilder = (fieldDescription, index) => {
		let card = '';
		if( fieldDescription.value.content.value )
			card += fieldDescription.value.content.value;
		if( card.length > 50 )
			card = card.substring(0,47) + '...';
		return card;
	}
	buildDescriptionPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<DescriptionPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly} 
			/>
		);
	}
	locationCardBuilder = (fieldLocation, index) => {
		let card = '';
		if( fieldLocation.value.place.value )
			card += fieldLocation.value.place.value;
		if( card.length > 40 )
			card = card.substring(0,37) + '...';
		return card;
	}
	buildLocationPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<LocationPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'dates'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'}}}
						 />
						<FieldEnum instance={instance} path={'type'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {maxWidth: '200px'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<FieldList_CardsPanel path={'descrList'} instance={instance} parentField={parentField} plain={plain} 
						buildItemComponent={this.buildDescriptionPanel} itemCardBuilder={this.descriptionCardBuilder} 
						labelEmptyToHeader={true} ignoreTitle={false} readOnly={readOnly}
						styles={{
							divMain: {
								padding: '10px 10px 10px 10px',
								backgroundColor: 'rgb(200,200,200)',
								border: '1px solid blue',
								marginTop: '10px',
								marginBottom: '10px'
							},
							divCardsBlock: {
								backgroundColor: 'rgb(200,200,200)',
								minWidth: '200px'
							},
							divCard: {
								marginTop: '3px',
								padding: '7px',
								cursor: 'pointer',
								backgroundColor: 'rgb(230,230,230)',
								minHeight: '18px'
							}
						}}
					/>
					<FieldList_CardsPanel path={'locations'} instance={instance} parentField={parentField} plain={plain} 
						buildItemComponent={this.buildLocationPanel} itemCardBuilder={this.locationCardBuilder} 
						labelEmptyToHeader={true} ignoreTitle={false} readOnly={readOnly}
						styles={{
							divMain: {
								padding: '10px 10px 10px 10px',
								backgroundColor: 'rgb(200,200,200)',
								border: '1px solid blue',
								marginTop: '10px',
								marginBottom: '10px'
							},
							divCardsBlock: {
								backgroundColor: 'rgb(200,200,200)',
								minWidth: '250px'
							},
							divCard: {
								marginTop: '3px',
								padding: '7px',
								cursor: 'pointer',
								backgroundColor: 'rgb(230,230,230)',
								minHeight: '18px'
							}
						}}
					/>
				</div>
			</div>
		)
	}
}

class DescriptionPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'language'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '200px', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'format'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'content'} parentField={parentField} />
						<FieldString  instance={instance} path={'content'} parentField={parentField} plain={plain} 
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldList_Strings instance={instance} path={'uri'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'}}}
						 />
					</div>
				</div>
			</div>
		)
	}
}

class LocationPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'role'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'language'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '3', width: '200px'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'dates'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						 />
						<FieldEnum instance={instance} path={'country'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '200px'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'index'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						 />
						<FieldEnum instance={instance} path={'area'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '200px'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'region'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'place'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldDecimal instance={instance} path={'latitude'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						 />
						<FieldDecimal instance={instance} path={'longitude'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'}}}
						 />
					</div>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'comment'} parentField={parentField} />
						<FieldString  instance={instance} path={'comment'} parentField={parentField} plain={plain} 
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default TabAAEvents;